import { render, staticRenderFns } from "./WarningDetail.vue?vue&type=template&id=6f70539d&scoped=true"
import script from "./WarningDetail.vue?vue&type=script&lang=js"
export * from "./WarningDetail.vue?vue&type=script&lang=js"
import style0 from "./WarningDetail.vue?vue&type=style&index=0&id=6f70539d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70539d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f70539d')) {
      api.createRecord('6f70539d', component.options)
    } else {
      api.reload('6f70539d', component.options)
    }
    module.hot.accept("./WarningDetail.vue?vue&type=template&id=6f70539d&scoped=true", function () {
      api.rerender('6f70539d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/WarningDetail.vue"
export default component.exports